/** Chat screen copy ported from the `advisors` i18n namespace (connect / chatting / leaveChat). */

export const connectCopy = {
  connectTitle: "Connecting you to advisor",
  connectSubtitle:
    "Your session is about to begin. Prepare your questions and get ready for the insights!",
  connectingStatus: "Connecting to advisor...",
  startChat: "Start chat",
  changeAdvisor: "Change advisor",
  secure: "Your chat is fully private and secure",
}

export const chattingCopy = {
  title: "Your advisor is here!",
  features: [
    "Ask your questions about anything",
    "Receive deep insights from the expert",
    "Let the insights guide you through",
  ],
  private: "Your chat is fully private and secure",
  message: "Type to ask...",
  mostPeople: "Most people ask about:",
  presets: [
    "Is my husband cheating on me?",
    "Will we get married?",
    "Will we have children together?",
    "Will my ex come back?",
    "Should I quit my job?",
    "When will my finances improve?",
    "Why am I always anxious or overwhelmed?",
    "Is my stress affecting my health?",
    "Why can’t I sleep properly anymore?",
    "Is my body trying to tell me something?",
  ],
}

export const leaveChatCopy = {
  title: "Are you sure?",
  subtitle:
    "Your session’s not over—your advisor may still have insights that could change your perspective. Here are some questions you might be thinking about:",
  keep: "Keep chatting",
  leave: "Finish reading",
  presets: [
    "When will my finances improve?",
    "Is my stress affecting my health?",
    "Will we get married?",
  ],
}
